if (!customElements.get('kp-category-rail')) {
  customElements.define('kp-category-rail', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.kp-categories__list');
      this.controls = this.querySelector('.kp-categories__controls');
      if (!this.rail || !this.controls) return;
      this.buttons = [...this.controls.querySelectorAll('[data-direction]')];
      this.update = () => {
        const end = this.rail.scrollWidth - this.rail.clientWidth;
        this.controls.hidden = end <= 2;
        this.buttons[0].disabled = this.rail.scrollLeft <= 2;
        this.buttons[1].disabled = this.rail.scrollLeft >= end - 2;
      };
      this.buttons.forEach((button) => button.addEventListener('click', () => {
        const item = this.rail.querySelector('.kp-categories__item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        this.rail.scrollBy({ left: Number(button.dataset.direction) * (item.clientWidth + gap) * 2, behavior: 'smooth' });
      }));
      this.rail.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.rail);
      this.update();
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
  });
}
